import React, { useEffect } from "react";
import Header from "../layout/header";
import $ from "jquery";
import WOW from "wowjs";
import CountUp from "react-countup";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Accordion from "react-bootstrap/Accordion";
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";
import {
  FaCalendarAlt,
  FaBolt,
  FaWater,
  FaEnvelope,
  FaCheck,
} from "react-icons/fa";

const REGISTER_URL =
  "https://www.globalsustainabilitychallenge.org/challenge-details/#preregister";
const CONTACT_EMAIL = "southasia@globalsustainabilitychallenge.org";

const keyFacts = [
  { label: "Venue", value: "IIT Bombay, Mumbai, India" },
  { label: "Regional Finale", value: "March 2027" },
  {
    label: "Global Finale",
    value: "Zhejiang University, Hangzhou · May 20–21, 2027",
  },
];

const countries = [
  "India",
  "Sri Lanka",
  "Nepal",
  "Bhutan",
  "Bangladesh",
  "Maldives",
];

const themes = [
  {
    icon: FaBolt,
    title: "Theme 01 — Sustainable Energy",
    desc: "Clean energy generation, storage, access, and efficiency — including microgrids and grid resilience for communities living with unreliable power.",
    focus: [
      "Generation",
      "Usage & Efficiency",
      "Industrial Energy",
      "Resource Scarcity",
      "Transmission & Storage",
    ],
  },
  {
    icon: FaWater,
    title: "Theme 02 — Adaptation & Resilience",
    desc: "Helping communities withstand, adapt to, and recover from climate shocks — now expanded beyond water alone.",
    focus: ["Water", "Food resilience (New)", "Heat resilience (New)"],
  },
];

const metrics = [
  { end: 250, suffix: "+", label: "Teams" },
  { end: 12, label: "Countries represented" },
  { end: 10, label: "Global finalist teams" },
  { end: 686, label: "Participants" },
  {
    prefix: "$",
    end: 35,
    suffix: "K+",
    label: "Prize pool + Stanford EcoGlobal",
  },
];

const phases = [
  {
    title: "Phase 1 : Ignite",
    period: "Sept – Nov 2026",
    items: [
      "Form a team and choose a theme",
      "Understand the problem and context",
      "Design your solution",
    ],
  },
  {
    title: "Phase 2 : Build",
    period: "Dec 2026 – Feb 2027",
    items: [
      "Build and test your solution",
      "Iterate and refine with feedback",
      "Showcase at the regional finale",
    ],
  },
  {
    title: "Phase 3 : Shine",
    period: "Mar – May 2027",
    items: [
      "Improve your solution",
      "Sharpen your storytelling",
      "Shine at the grand finale",
    ],
  },
];

const faqs = [
  {
    q: "Who can participate in GSC South Asia?",
    a: "Students currently enrolled in a university or college across India, Sri Lanka, Bangladesh, Bhutan, Maldives, or Nepal — undergrad or postgrad.",
  },
  {
    q: "Do I need to be from a specific field of study?",
    a: "No. GSC welcomes students from engineering, design, business, environmental science, policy, and beyond. Cross-disciplinary teams are encouraged.",
  },
  {
    q: "Can I participate individually, or do I need a team?",
    a: "Interdisciplinary teams of 1-6 university students from anywhere in the world can participate. At least one team member must be 18 or older by January 1, 2027.",
  },
  {
    q: "Can my team include members from different countries?",
    a: "Yes — team members can be from different regions, but the team would have to choose to represent one region.",
  },
  {
    q: "How do I register?",
    a: "Registration happens on the official GSC platform — click “Register” in the nav, which takes you to the official Hub. This site is the regional information hub; official sign-up always happens on globalsustainabilitychallenge.org.",
  },
  {
    q: "Is there a registration fee?",
    a: "No — the Global Sustainability Challenge is free to enter for eligible students across all regions.",
  },
  {
    q: "Is it compulsory to participate in person for the regional finale? Can my team showcase online?",
    a: "Your team can participate either online or in person in the Regional Finale.",
  },
];

const partnerInstitutions = [
  "IIT Bombay — Regional Ambassador & Founding Partner",
  "Stanford Doerr School of Sustainability",
  "Technical University of Munich",
  "Hong Kong University of Science and Technology",
  "Zhejiang University",
  "UNESP",
  "YGA",
];

export default function GlobalSustainabilityChallenge() {
  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <>
      <Header></Header>

      <Metatag
        title="Global Sustainability Challenge — South Asia | IIT Bombay"
        description="GSC South Asia is the regional hub of the Global Sustainability Challenge, hosted by IIT Bombay — a student competition to design, build, and showcase real-world sustainability solutions."
        keywords="Global Sustainability Challenge, GSC South Asia, IIT Bombay, sustainability competition, student challenge"
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0">
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Global Sustainability Challenge
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Banner + Key Facts */}
      <Container className="my-5 pt-md-5 pt-4 event-info">
        <div className="rounded-4 bg-light shadow-sm position-relative overflow-hidden">
          <Row className="p-md-4 p-3 align-items-start g-4">
            <Col md={7} className="ps-md-4 px-3 pe-md-5">
              <h2 className="h4 wow fadeInUp">
                Global Sustainability Challenge is back
              </h2>
              <p className="lh-base mb-4 wow fadeInUp">
                Design, build, and showcase real-world sustainability solutions
                on a global stage.
              </p>
              <div className="mb-4">
                {keyFacts.map((fact, index) => (
                  <div key={index} className="mb-2 wow fadeInUp">
                    <h6 className="fw-medium ">
                      {fact.label}
                    </h6>
                    <span>{fact.value}</span>
                  </div>
                ))}
              </div>
              <a
                href={REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary rounded-pill px-4 py-2 wow fadeInUp"
              >
                Register Free
              </a>
            </Col>
            <Col md={5}>
              <img
                src={
                  globalVariables.variables.strDomainUrl +
                  "images/global-sustainability-challenge-talk.png"
                }
                className="img-fluid w-100 rounded-3 border"
                alt="Global Sustainability Challenge"
                title="Global Sustainability Challenge"
              />
            </Col>
          </Row>
        </div>
      </Container>

      {/* About GSC */}
      <Container className="my-md-5 my-4">
        <Row className="g-0">
          <Col md={12}>
            <div className="border rounded-4 p-md-5 p-4">
              <h2 className="h4 mb-3 wow fadeInUp">About GSC</h2>
              <Row className="align-items-start g-4">
                <Col md={7}>
                  <p className="wow fadeInUp">
                    The Global Sustainability Challenge (GSC) is an annual
                    global student competition where teams design, prototype,
                    and present real-world solutions addressing critical
                    sustainability challenges.
                  </p>
                  <p className="wow fadeInUp">
                    IIT Bombay is the Regional Ambassador for South Asia and
                    Founding Partner in this collaboration alongside the
                    Stanford Doerr School of Sustainability, Technical
                    University of Munich, Hong Kong University of Science and
                    Technology, Zhejiang University, UNESP and YGA.
                  </p>
                  <div className="bg-primary bg-opacity-10 rounded-4 p-4 mt-4 text-center wow fadeInUp">
                    <h6 className="text-uppercase mb-2">
                      Our Mission
                    </h6>
                    <p className="m-0 fw-medium">
                      Educate, inspire, and mobilize youth worldwide for
                      sustainability action
                    </p>
                  </div>
                </Col>
                <Col md={5}>
                  <img
                    src={
                      globalVariables.variables.strDomainUrl +
                      "images/global-sustainability-challenge.png"
                    }
                    className="img-fluid w-100 rounded-3 wow fadeInUp border"
                    alt="About Global Sustainability Challenge"
                    title="About Global Sustainability Challenge"
                  />
                </Col>
              </Row>

              <div className="mt-4 pt-4 border-top">
                <div className="d-flex flex-wrap align-items-start gap-3">
                  <h6 className="h4 mb-0 text-nowrap wow fadeInUp">
                    Collaboration
                  </h6>
                  <Row className="row-cols-2 row-cols-md-4 g-3 mx-0 flex-grow-1">
                    {partnerInstitutions.map((name, index) => (
                      <Col key={index}>
                        <div className="border rounded-3 p-3 h-100 d-flex align-items-center justify-content-center text-center small fw-medium wow fadeInUp">
                          {name}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>

              <div className="mt-4 pt-4 border-top">
                <Row className="align-items-start g-4">
                  <Col md={5}>
                    <img
                      src={
                        globalVariables.variables.strDomainUrl +
                        "images/south-asia-map.jpeg"
                      }
                      className="wow fadeInUp border rounded-4 w-100"
                      alt="Map of GSC South Asia region: India, Sri Lanka, Nepal, Bhutan, Bangladesh, Maldives"
                      title="GSC South Asia Region"
                    />
                  </Col>
                  <Col md={7}>
                    <h2 className="h4 wow fadeInUp">About the Region</h2>
                    <p className="text-primary wow fadeInUp">
                      Six Countries. Endless Possibilities.
                    </p>
                    <p className="wow fadeInUp">
                      From monsoon disruptions in India and rising seas in the
                      Maldives to Himalayan water security in Nepal and Bhutan,
                      and growing demands for climate resilience across
                      Bangladesh and Sri Lanka, the region faces challenges that
                      are deeply interconnected yet uniquely local.
                    </p>
                    <p className="wow fadeInUp">
                      GSC South Asia brings together young innovators to
                      exchange perspectives, challenge assumptions, and build
                      solutions grounded in the realities of the region -
                      turning diverse challenges into opportunities for
                      innovation and impact.
                    </p>
                    <div className="d-flex flex-wrap gap-2 my-2">
                      {countries.map((country, index) => (
                        <span
                          key={index}
                          className="text-primary fw-medium wow fadeInUp"
                        >
                          {country}
                          {index < countries.length - 1 && (
                            <span className="mx-2 text-muted">•</span>
                          )}
                        </span>
                      ))}
                    </div>
                    <p className="wow fadeInUp mb-0">
                      As the South Asia hub, it anchors outreach, mentorship,
                      and the regional final for teams across the six-nation
                      region - one of five regional finals worldwide that feed
                      into a single Global Finale. Teams that place advance to
                      represent the region on the global stage, alongside
                      finalists from other regions of the world.
                    </p>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Challenge Themes */}
      <Container className="my-4 my-md-5">
        <h2 className="h4 text-center mb-4 wow fadeInUp">
          Challenge Themes - 2026–27
        </h2>
        <Row className="row-cols-1 row-cols-md-2 g-4">
          {themes.map((theme, index) => {
            const Icon = theme.icon;
            return (
              <Col key={index}>
                <div className="border rounded-4 p-4 p-lg-5 h-100 wow fadeInUp">
                  <Icon className="text-primary mb-3" size={32} />
                  <h5 className="mb-3">{theme.title}</h5>
                  <p>{theme.desc}</p>
                 
                  <div className="d-flex flex-wrap gap-2 my-2">
                      {theme.focus.map((f, i) => (
                        <span
                          key={i}
                          className="text-primary fw-medium wow fadeInUp"
                        >
                          {f}
                          {i < theme.focus.length - 1 && (
                            <span className="mx-2 text-muted">•</span>
                          )}
                        </span>
                      ))}
                    </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>

      {/* Metrics - Last Season */}
      <Container className="my-md-5 my-4">
        <Row className="g-0">
          <Col md={12}>
            <div className="border rounded-4 p-md-5 p-4">
              <h2 className="h4 text-center mb-4 wow fadeInUp">
                Metrics - Last Season
              </h2>
              <Row className="row-cols-2 row-cols-md-5 g-3 text-center">
                {metrics.map((metric, index) => (
                  <Col key={index}>
                    <div className="bg-primary bg-opacity-10 rounded-4 p-3 h-100 wow fadeInUp">
                      <h2 className="text-primary fw-bold mb-1">
                        <CountUp
                          start={0}
                          end={metric.end}
                          prefix={metric.prefix || ""}
                          suffix={metric.suffix || ""}
                          separator=","
                          enableScrollSpy
                        />
                      </h2>
                      <p className="m-0 small">{metric.label}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Registration */}
      <Container className="my-md-5 my-4">
        <Row className="g-0">
          <Col md={12}>
            <div className="bg-light-green rounded-4 p-md-5 p-4">
              <div className="col-md-9 mx-auto text-center">
                <h2 className="h4 mb-3 wow fadeInUp">Registration</h2>
                <p className="mb-4 wow fadeInUp">
                  This site is the South Asia regional information hub —
                  official registration always happens on the GSC platform.
                </p>
                <a
                  href={REGISTER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary rounded-pill px-4 py-2 wow fadeInUp"
                >
                  Register Free
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Season Timeline */}
      <Container className="my-md-5 my-4">
        <h2 className="h4 text-center mb-4 wow fadeInUp">
          Season 2026–27 Tenure Timeline
        </h2>
        <Row className="row-cols-1 row-cols-md-3 g-4">
          {phases.map((phase, index) => (
            <Col key={index}>
              <div className="border rounded-4 h-100 overflow-hidden wow fadeInUp">
                <div className="bg-primary text-white p-3 text-center">
                  <h6 className="m-0">{phase.title}</h6>
                  <small className="d-flex align-items-center justify-content-center gap-1 mt-1">
                    <FaCalendarAlt /> {phase.period}
                  </small>
                </div>
                <div className="p-4">
                  <ul className="list-unstyled m-0">
                    {phase.items.map((item, i) => (
                      <li
                        key={i}
                        className="d-flex align-items-start gap-2 mb-2"
                      >
                        <FaCheck className="text-primary mt-1 flex-shrink-0" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* FAQs */}
      <Container className="my-md-5 my-4" id="faqs">
        <Row className="g-0">
          <Col md={12}>
            <div className="border rounded-4 p-md-5 p-4">
              <h2 className="h4 text-center mb-4 wow fadeInUp">
                FAQs
              </h2>
              <Col md={10} className="mx-auto">
                <Accordion defaultActiveKey="" flush>
                  {faqs.map((faq, index) => (
                    <Accordion.Item
                      key={index}
                      eventKey={index.toString()}
                      className="overflow-hidden mb-2"
                    >
                      <Accordion.Header>{faq.q}</Accordion.Header>
                      <Accordion.Body>{faq.a}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Col>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Contact */}
      <Container className="my-md-5 my-4" id="contact">
        <Row className="g-0">
          <Col md={12}>
            <div className="bg-primary bg-opacity-10 rounded-4 p-md-5 p-4 text-center">
              <FaEnvelope className="text-primary mb-2" size={28} />
              <h2 className="h4 mb-2 wow fadeInUp">
                GSC South Asia Partners and Team Contact
              </h2>
              <p className="mb-3 wow fadeInUp">
                Students, educators & partners
              </p>
              <p className="col-md-8 mx-auto wow fadeInUp">
                Questions about eligibility, registration, themes, the South
                Asia timeline, or partnership opportunities — write to us
                directly.
              </p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="btn btn-primary rounded-pill px-4 py-2 text-break mw-100 wow fadeInUp"
              >
                {CONTACT_EMAIL}
              </a>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer note */}
      <Container className="my-md-5 my-4">
        <p className="text-center small text-muted fst-italic">
          GSC South Asia — a regional chapter of the Global Sustainability
          Challenge, hosted by IIT Bombay. Full programme details:{" "}
          <a
            href="https://www.globalsustainabilitychallenge.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            globalsustainabilitychallenge.org
          </a>
        </p>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={globalVariables.variables.strDomainUrl + "outreach/partners"}
        >
          Outreach
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          Global Sustainability Challenge
        </Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
